/* https://stackoverflow.com/a/25490531
   Adapted to return undefined on no matches
*/

export const getCookieValue = a => {
  const b = document.cookie.match(`(^|;)\\s*${a}\\s*=\\s*([^;]+)`)
  return b ? b.pop() : undefined
}
